import { platformRequest } from '@/core/api/platformApi';
import type { SupportImageUpload, SupportMessage, TenantSupportConversation } from '@/core/api/tenantSupportApi';

export interface PlatformSupportConversationSummary {
  tenantId: string;
  tenantName: string;
  tenantCode: string;
  tenantStatus: string;
  lastMessageAtUtc: string;
  unreadCount: number;
  lastMessage: string;
  lastSenderType: string;
  lastSenderDisplayName: string;
}

export interface PlatformBaleSettings {
  isEnabled: boolean;
  hasBotToken: boolean;
  botUsername: string | null;
  publicApiBaseUrl: string | null;
  managerChatId: number | null;
  notifyPlatformOnTenantMessage: boolean;
  webhookUrl: string | null;
}

export interface UpdatePlatformBaleSettingsPayload {
  isEnabled: boolean;
  botToken: string | null;
  clearBotToken: boolean;
  botUsername: string | null;
  publicApiBaseUrl: string | null;
  managerChatId: number | null;
  notifyPlatformOnTenantMessage: boolean;
}

export interface BaleConnectionTestResult {
  isSuccessful: boolean;
  botUsername: string;
  testMessageDelivered: boolean;
  message: string;
}

export const platformSupportApi = {
  list: (): Promise<PlatformSupportConversationSummary[]> => platformRequest('/api/v1/platform/support/conversations'),
  conversation: (tenantId: string): Promise<TenantSupportConversation> => platformRequest(`/api/v1/platform/support/conversations/${tenantId}`),
  send: (tenantId: string, message: string | null, attachmentId: string | null = null): Promise<SupportMessage> => platformRequest(`/api/v1/platform/support/conversations/${tenantId}/messages`, { method: 'POST', body: JSON.stringify({ message, attachmentId }) }),
  uploadImage: (tenantId: string, file: File): Promise<SupportImageUpload> => {
    const body = new FormData();
    body.append('file', file);
    return platformRequest(`/api/v1/platform/support/conversations/${tenantId}/images`, { method: 'POST', body });
  },
  baleSettings: (): Promise<PlatformBaleSettings> => platformRequest('/api/v1/platform/settings/bale'),
  updateBaleSettings: (payload: UpdatePlatformBaleSettingsPayload): Promise<PlatformBaleSettings> => platformRequest('/api/v1/platform/settings/bale', { method: 'PUT', body: JSON.stringify(payload) }),
  testBale: (): Promise<BaleConnectionTestResult> => platformRequest('/api/v1/platform/settings/bale/test', { method: 'POST' }),
  registerBaleWebhook: (): Promise<PlatformBaleSettings> => platformRequest('/api/v1/platform/settings/bale/webhook', { method: 'POST' }),
};
